import message from "../components/chat_msg_view";

export default {
  props: ["search_keyword"],
  name: 'chatmsg_search',
  components: {message},
  data () {
    return {
      err_msg: '',
      snackbar: false,
      reload_msg:0,
    }
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    async selectedGroup() {
      return await this.$store.getters.selectedGroup;
    },
  },
  mounted () {

  },
  methods: {

  },
  watch: {

  }

}